module.exports = __webpack_public_path__ + "static/media/TCF.6e722824.jpg";